(function () {
  function bindBewoHfpCartForm(form) {
    if (!form || form.dataset.bewoHfpCartBound === 'true') return;
    form.dataset.bewoHfpCartBound = 'true';

    const variantInput = form.querySelector('input[name="id"]');
    const submitButton = form.querySelector('[type="submit"]');
    const errorMessage = form.querySelector('.product-form__error-message');

    if (variantInput && !submitButton?.disabled) {
      variantInput.disabled = false;
    }

    const showError = (message) => {
      if (!message) {
        errorMessage?.setAttribute('hidden', '');
        if (errorMessage) errorMessage.textContent = '';
        return;
      }

      if (errorMessage) {
        errorMessage.removeAttribute('hidden');
        errorMessage.textContent = message;
      } else {
        window.alert(message);
      }
    };

    form.addEventListener('submit', (event) => {
      if (!window.BewoTheme) return;
      if (document.body.classList.contains('cart-template') || BewoTheme.settings.cartType === 'page') return;

      event.preventDefault();
      if (!variantInput?.value || submitButton?.disabled || submitButton?.hasAttribute('aria-disabled')) return;

      showError('');

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const config = BewoTheme.utils.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      formData.append('sections', sectionsToBundle);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      submitButton?.setAttribute('aria-disabled', 'true');
      submitButton?.classList.add('btn--loading');

      fetch(`${BewoTheme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (parsedState) => {
          if (parsedState.status) {
            showError(parsedState.description || parsedState.message || 'Não foi possível adicionar ao carrinho.');
            BewoTheme.pubsub.publish(BewoTheme.pubsub.PUB_SUB_EVENTS.cartError, {
              source: 'bewo-hfp-form',
              productVariantId: formData.get('id'),
              errors: parsedState.errors || parsedState.description,
              message: parsedState.message,
            });
            return;
          }

          document.dispatchEvent(
            new CustomEvent('product-ajax:added', {
              detail: { product: parsedState },
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { open: true },
            })
          );
        })
        .catch((error) => {
          console.error(error);
          showError('Não foi possível adicionar ao carrinho.');
        })
        .finally(() => {
          submitButton?.classList.remove('btn--loading');
          submitButton?.removeAttribute('aria-disabled');
        });
    });
  }

  function initSection(root) {
    if (!root || root.dataset.bewoProductReady === 'true') return;
    root.dataset.bewoProductReady = 'true';

    const section = root.closest('[data-section]') || root.closest('.shopify-section');
    const dataEl = section?.querySelector('[data-bewo-media-data]');
    let images = [];

    if (dataEl) {
      try {
        images = JSON.parse(dataEl.textContent).map((entry) =>
          typeof entry === 'string' ? { src: entry, ratio: 0 } : { src: entry.src, ratio: Number(entry.ratio) || 0 }
        );
      } catch (error) {
        console.warn(error);
      }
    }

    const thumbs = Array.from(root.querySelectorAll('.bewo-product__thumb'));
    const mainImage = root.querySelector('.bewo-product__media-image');
    const media = root.querySelector('.bewo-product__media');
    const prevBtn = root.querySelector('.bewo-product__nav--prev');
    const nextBtn = root.querySelector('.bewo-product__nav--next');
    const zoomBtn = root.querySelector('.bewo-product__zoom');
    const shareBtn = root.querySelector('[data-bewo-share]');
    const questionBtn = root.querySelector('[data-bewo-question]');
    const accordionItems = Array.from(root.querySelectorAll('.bewo-product__accordion details'));
    const qtyInput = root.querySelector('.bewo-product__qty input');
    const qtyMinus = root.querySelector('.bewo-product__qty button[data-qty-minus]');
    const qtyPlus = root.querySelector('.bewo-product__qty button[data-qty-plus]');

    let currentSlide = Number(root.dataset.bewoInitialSlide || 0);

    function applyRatio(ratio) {
      if (!media || !ratio || !Number.isFinite(ratio)) return;
      media.style.setProperty('--bewo-media-ratio', String(ratio));
    }

    function setSlide(index) {
      if (!mainImage || !images.length) return;

      currentSlide = (index + images.length) % images.length;
      const entry = images[currentSlide];

      applyRatio(entry.ratio);

      mainImage.src = entry.src;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');

      thumbs.forEach((thumb, i) => {
        const active = i === currentSlide;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    mainImage?.addEventListener('load', () => {
      if (mainImage.naturalWidth && mainImage.naturalHeight) {
        applyRatio(mainImage.naturalWidth / mainImage.naturalHeight);
      }
    });

    if (images.length) {
      setSlide(currentSlide);
    }

    if (images.length > 1) {
      images.forEach((entry, index) => {
        if (index === currentSlide) return;
        const preload = new Image();
        preload.src = entry.src;
      });
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => setSlide(index));
    });

    prevBtn?.addEventListener('click', () => setSlide(currentSlide - 1));
    nextBtn?.addEventListener('click', () => setSlide(currentSlide + 1));

    zoomBtn?.addEventListener('click', () => {
      media?.classList.toggle('is-zoomed');
    });

    function updateQty(delta) {
      if (!qtyInput) return;
      const value = Math.max(1, Math.min(99, Number(qtyInput.value || 1) + delta));
      qtyInput.value = String(value);
    }

    qtyMinus?.addEventListener('click', () => updateQty(-1));
    qtyPlus?.addEventListener('click', () => updateQty(1));

    const giftPicker = root.querySelector('[data-bewo-gift-picker]');
    const variantInput = root.querySelector('input.product-variant-id, input[name="id"]');
    const cartBtn = root.querySelector('.bewo-product__cart[type="submit"], .bewo-hfp__cart[type="submit"]');

    if (giftPicker && variantInput) {
      const syncGiftVariant = (radio) => {
        if (!radio?.checked) return;
        const variantId = radio.dataset.variantId || radio.value;
        const available = String(radio.dataset.variantAvailable) !== 'false';
        const giftLabel = radio.dataset.giftLabel || radio.closest('label')?.querySelector('span')?.textContent?.trim() || '';

        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));

        document.querySelectorAll('sticky-atc-bar input[name="id"], sticky-atc-bar select[name="id"]').forEach((el) => {
          el.value = variantId;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });

        // Line-item property so checkout/admin always show the chosen gift clearly.
        const giftPropertyInputs = [
          ...root.querySelectorAll('input.bewo-gift-property, input[name="properties[Brinde]"]'),
          ...document.querySelectorAll('sticky-atc-bar input[name="properties[Brinde]"]'),
        ];
        giftPropertyInputs.forEach((el) => {
          el.value = giftLabel;
        });

        giftPicker.querySelectorAll('.bewo-product__gift-option').forEach((label) => {
          label.classList.toggle('is-selected', label.contains(radio));
        });

        const mediaIndex = radio.dataset.mediaIndex;
        if (mediaIndex !== undefined && mediaIndex !== '' && images.length) {
          setSlide(Number(mediaIndex));
        }

        if (cartBtn) {
          cartBtn.disabled = !available;
          const labelEl = cartBtn.querySelector('.bewo-product__cart-label, .bewo-hfp__cart-label');
          if (labelEl) {
            labelEl.textContent = available
              ? (window.BewoTheme?.variantStrings?.addToCart || 'Adicionar ao carrinho')
              : (window.BewoTheme?.variantStrings?.soldOut || 'Esgotado');
          }
        }

        // Keep sticky ATC in sync with the chosen gift variant.
        const sticky = document.querySelector(`sticky-atc-bar[data-product-id="${root.closest('product-info')?.dataset?.productId || ''}"]`)
          || document.querySelector('sticky-atc-bar');
        if (sticky) {
          sticky.selectedVariantId = String(variantId);
          const stickyVariant = sticky.variantData?.find((v) => String(v.id) === String(variantId));
          if (stickyVariant) {
            sticky.currentVariant = stickyVariant;
            if (typeof sticky.updatePrice === 'function') sticky.updatePrice();
            if (typeof sticky.updateButton === 'function') {
              sticky.updateButton(!stickyVariant.available, window.BewoTheme?.variantStrings?.soldOut);
            }
          }
        }
      };

      giftPicker.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => syncGiftVariant(radio));
        if (radio.checked) syncGiftVariant(radio);
      });
    }

    // O estado de loading é controlado por quem envia o form (product-form do tema
    // na PDP, handler próprio na home). Observar a saída de .btn--loading cobre os dois.
    const cartButton = root.querySelector('.bewo-product__cart, .bewo-hfp__cart');

    if (cartButton && typeof MutationObserver !== 'undefined') {
      let wasLoading = cartButton.classList.contains('btn--loading');
      let addedTimer = null;

      new MutationObserver(() => {
        const isLoading = cartButton.classList.contains('btn--loading');

        if (wasLoading && !isLoading) {
          cartButton.classList.remove('is-added');
          // reflow para reiniciar a animação em cliques consecutivos
          void cartButton.offsetWidth;
          cartButton.classList.add('is-added');

          window.clearTimeout(addedTimer);
          addedTimer = window.setTimeout(() => cartButton.classList.remove('is-added'), 1200);
        }

        wasLoading = isLoading;
      }).observe(cartButton, { attributes: true, attributeFilter: ['class'] });
    }

    accordionItems.forEach((item) => {
      const toggle = item.querySelector('.bewo-product__accordion-toggle');

      const syncToggle = () => {
        if (toggle) toggle.textContent = item.open ? '−' : '+';
      };

      item.addEventListener('toggle', syncToggle);
      syncToggle();
    });

    shareBtn?.addEventListener('click', async () => {
      const shareData = {
        title: document.title,
        text: shareBtn.dataset.shareText || document.title,
        url: window.location.href,
      };

      if (navigator.share) {
        try {
          await navigator.share(shareData);
        } catch (error) {
          if (error.name !== 'AbortError') console.warn(error);
        }
        return;
      }

      try {
        await navigator.clipboard.writeText(window.location.href);
        const original = shareBtn.innerHTML;
        shareBtn.textContent = 'Link copiado';
        window.setTimeout(() => {
          shareBtn.innerHTML = original;
        }, 1800);
      } catch {
        window.prompt('Copie o link:', window.location.href);
      }
    });

    questionBtn?.addEventListener('click', (event) => {
      const href = questionBtn.getAttribute('href');
      if (href && href !== '#') return;
      event.preventDefault();
      window.location.href = '/pages/contact';
    });

    bindBewoHfpCartForm(root.querySelector('.bewo-hfp__form'));
  }

  function initAll() {
    document.querySelectorAll('[data-bewo-product]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-bewo-product]');
    if (root) initSection(root);
  });
})();
